import * as React from "react";
export default function WartaBeritaHero() {
  return <section id="wartaberitahero" className="zona-pp-hero zona-pp-hero-accent bg-white py-12 md:py-20 border-b border-border">
      <div className="container mx-auto px-4">
        <h1 className="text-[28px] md:text-5xl font-bold text-foreground tracking-tighter uppercase">
          Warta & Berita
        </h1>
      </div>
    </section>;
}